import React, { PureComponent } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import Immutable from 'immutable';
import Avatar from '../Avatar';

import Delete from './ActivityTypes/Delete';
import Create from './ActivityTypes/Create';
import Comment from './ActivityTypes/Comment';
import CreateProp from './ActivityTypes/CreateProp';
import UpdateProp from './ActivityTypes/UpdateProp';
import UpdateRelProp from './ActivityTypes/UpdateRelProp';
import RenameProp from './ActivityTypes/RenameProp';
import Rename from './ActivityTypes/Rename';
import Relationship from './ActivityTypes/Relationship';

const ActivityWrapper = styled.div`
  display: flex;
  align-self: center;
  justify-content: space-between;
  flex: none;
  width: 100%;
  font-family: Arial, sans-serif;
  font-size: 14px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0.75rem;
  margin-bottom: -1px;
`;

const TimeStamp = styled.span`
  margin-left: 0.8rem;
  color: rgba(0, 0, 0, 0.4);
  font-weight: 400;
  font-size: 0.85714286em;
  font-style: normal;
`;

class Activity extends PureComponent {
  _pushCallback = (projectId, id, typeOverride) => {
    const { dispatch, push } = this.props;

    switch (typeOverride) {
      case 'elementType':
        dispatch(push(`/project/${projectId}/settings/element-type/${id}`));
        break;
      case 'relationshipType':
        dispatch(
          push(`/project/${projectId}/settings/relationship-type/${id}`),
        );
        break;
      default:
        dispatch(push(`/project/${projectId}/element/${id}`));
        break;
    }
  };

  _parseActivity = activity => {
    if (activity.type === 'update' && activity.subtype === 'prop') {
      if (activity.subaction === 'update') {
        if (activity.objectable_type === 'relationship') {
          return (
            <UpdateRelProp
              activity={activity}
              _pushCallback={this._pushCallback}
            />
          );
        } else {
          return (
            <UpdateProp
              activity={activity}
              _pushCallback={this._pushCallback}
            />
          );
        }
      }
      if (activity.subaction === 'rename')
        return (
          <RenameProp activity={activity} _pushCallback={this._pushCallback} />
        );
    }

    if (activity.type === 'delete') {
      if (activity.subtype === 'relationship')
        return (
          <Relationship
            deleteTest
            activity={activity}
            _pushCallback={this._pushCallback}
          />
        );
      return <Delete activity={activity} _pushCallback={this._pushCallback} />;
    }

    if (activity.type === 'create') {
      if (activity.objectable_type === 'comment')
        return (
          <Comment activity={activity} _pushCallback={this._pushCallback} />
        );
      if (activity.subtype === 'prop')
        return (
          <CreateProp activity={activity} _pushCallback={this._pushCallback} />
        );
      if (activity.subtype === 'relationship')
        return (
          <Relationship
            deleteTest={false}
            activity={activity}
            _pushCallback={this._pushCallback}
          />
        );
      return <Create activity={activity} _pushCallback={this._pushCallback} />;
    }

    if (activity.type === 'update' && activity.subaction === 'rename') {
      return <Rename activity={activity} _pushCallback={this._pushCallback} />;
    }

    return <div>caca</div>;
  };

  render() {
    const { activity, notificationOverride } = this.props;

    return (
      <ActivityWrapper className="feed-item">
        <div
          style={{
            display: 'flex',
            flex: 'none',
            justifyContent: 'flex-start',
            marginRight: 10,
          }}
        >
          <Avatar
            className="mr-1"
            avatar={Immutable.fromJS(activity.user.avatar)}
            user={Immutable.fromJS(activity.user)}
            notificationOverride={notificationOverride}
            width="37"
            height="37"
            rounded
          />
        </div>
        <div style={{ display: 'flex', flex: 3 }}>{this._parseActivity(activity)}</div>
        <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
          <TimeStamp>{moment(activity.created_at).fromNow()}</TimeStamp>
        </div>
      </ActivityWrapper>
    );
  }
}

export default Activity;



// WEBPACK FOOTER //
// ./src/components/ActivityFeed/Activity.js